module.exports = "<app-search [query]=\"query\" [data]=\"data\" [type]=\"type\" [disable]=\"disable\" [cart]=\"cart\"></app-search>"